module.exports = __webpack_public_path__ + "static/media/doc-update.fbe693fa.svg";